import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const barCodeShipmentLineListReducer = (state = [], action) => {
  const actionName = serverApis.getBarCodeShipmentLineList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.po_lines;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
